import useFetch from '../../../hooks/useFetch';
import { useState } from 'react';
import { Carrier, CarrierFilters } from '../../models/Carrier';
import { ServiceEvents } from '../shared/interfaces';
import { EndPoints } from '../EndPoints';

const useCarrierService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingGetCarriers, setFetchingGetCarriers] = useState(false);
    const [fetchingShowCarrier, setFetchingShowCarrier] = useState(false);
    const [fetchingCreateCarrier, setFetchingCreateCarrier] = useState(false);
    const [fetchingStoreCarrier, setFetchingStoreCarrier] = useState(false);
    const [fetchingEditCarrier, setFetchingEditCarrier] = useState(false);
    const [fetchingUpdateCarrier, setFetchingUpdateCarrier] = useState(false);
    const [fetchingDeleteCarrier, setFetchingDeleteCarrier] = useState(false);
    const [fetchingGetCarrier, setFetchingGetCarrier] = useState(false);
    const [fetchingActiveCarrier, setFetchingActiveCarrier] = useState(false);

    const getCarriers = (carrierFilters: CarrierFilters, events: ServiceEvents = {}) => {
        const queryString = Object.entries(carrierFilters)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');

        const url = `${EndPoints.CARRIERS.GET_CARRIERS}?${queryString}`;
        doGet({
            ...events,
            url: url,
            setFetching: setFetchingGetCarriers
        });
    };

    const showCarrier = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.CARRIERS.SHOW_CARRIER.replace(':id', id.toString()),
            setFetching: setFetchingShowCarrier
        });
    };

    const getCarrier = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.CARRIERS.GET_CARRIER.replace(':id', id.toString()),
            setFetching: setFetchingGetCarrier
        });
    };

    const createCarrier = (events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.CARRIERS.CREATE_CARRIER,
            setFetching: setFetchingCreateCarrier
        });
    };

    const storeCarrier = (carrier: Carrier, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.CARRIERS.STORE_CARRIER,
            requestType: 'multipart',
            body: carrier,
            setFetching: setFetchingStoreCarrier
        });
    };

    const editCarrier = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.CARRIERS.EDIT_CARRIER.replace(':id', id.toString()),
            setFetching: setFetchingEditCarrier
        });
    };

    const updateCarrier = (id: number, carrier: Carrier, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: EndPoints.CARRIERS.UPDATE_CARRIER.replace(':id', id.toString()),
            body: carrier,
            setFetching: setFetchingUpdateCarrier
        });
    };

    const deleteCarrier = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            url: EndPoints.CARRIERS.DELETE_CARRIER.replace(':id', id.toString()),
            setFetching: setFetchingDeleteCarrier
        });
    };

    const activeCarrier = (id: number, active: boolean, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.CARRIERS.ACTIVE_CARRIER.replace(':id', id.toString()),
            body: { active: active },
            setFetching: setFetchingActiveCarrier
        });
    };

    return {
        fetchingGetCarriers,
        fetchingShowCarrier,
        fetchingGetCarrier,
        fetchingCreateCarrier,
        fetchingStoreCarrier,
        fetchingEditCarrier,
        fetchingUpdateCarrier,
        fetchingDeleteCarrier,
        fetchingActiveCarrier,
        activeCarrier,
        getCarriers,
        showCarrier,
        getCarrier,
        createCarrier,
        storeCarrier,
        editCarrier,
        updateCarrier,
        deleteCarrier
    };
};

export default useCarrierService;
